import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

// A slim bar across the top while the next page loads, so filter and page changes never feel stuck.
export const RouteProgress: FC = (): ReactNode => {
    const router = useRouter()
    const [active, setActive] = useState(false)

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | null = null

        const start = (url: string, { shallow }: { shallow: boolean }) => {
            if (shallow) return

            timer = setTimeout(() => setActive(true), 120)
        }

        const done = () => {
            if (timer) clearTimeout(timer)

            timer = null
            setActive(false)
        }

        router.events.on('routeChangeStart', start)
        router.events.on('routeChangeComplete', done)
        router.events.on('routeChangeError', done)

        return () => {
            if (timer) clearTimeout(timer)

            router.events.off('routeChangeStart', start)
            router.events.off('routeChangeComplete', done)
            router.events.off('routeChangeError', done)
        }
    }, [router.events])

    return (
        <div
            aria-hidden='true'
            className={`pointer-events-none fixed inset-x-0 top-0 z-[60] h-0.5 overflow-hidden transition-opacity duration-300 ${active ? 'opacity-100' : 'opacity-0'}`}
        >
            <div className='animate-route-progress h-full w-1/3 bg-linear-to-r from-transparent via-brand to-transparent' />
        </div>
    )
}
